export const getItemToFocus = ({ startIndex, items }) => {
    for (let i = startIndex; i <= items.length - 1; i++) {
        const item = items[i];

        if (!item.disabled) {
            return item.ref;
        }
    }
};
